var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84293 2.27963C9.35059 2.27963 11.412 4.3249 11.412 6.86019C11.412 7.81891 11.1145 8.71372 10.5619 9.502L10.1156 10.1411L9.4781 10.5885C8.6918 11.1425 7.79924 11.4407 6.84293 11.4407C4.33527 11.4407 2.27389 9.39547 2.27389 6.86019C2.27389 4.3249 4.33527 2.27963 6.84293 2.27963ZM6.84293 0C3.06019 0 0 3.06791 0 6.86019C0 10.6525 3.06019 13.7204 6.84293 13.7204C8.30927 13.7204 9.66936 13.2517 10.7957 12.4421L14.0046 15.6591C14.2171 15.8722 14.5147 16 14.8122 16C15.1097 16 15.4072 15.8935 15.6197 15.6591L15.641 15.6378C16.0873 15.1904 16.151 14.4447 15.641 14.0186L12.432 10.8229C13.2183 9.69374 13.7071 8.33023 13.7071 6.86019C13.6859 3.06791 10.6257 0 6.84293 0Z",
    fill: "#554937"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.625c7d5cfdec82069890e438e0bd5564.svg";
export { ForwardRef as ReactComponent };